import React from 'react';
import { Container } from '@mui/material';
import PageUnderConstruction from '../components/UnderConstruction/PageUnderConstruction';

function Contact() {
	return (
		<Container>
			<PageUnderConstruction />
		</Container>
	);
}

export default Contact;
